module.exports = __webpack_public_path__ + "components/country-flag/static/bm-ae78028c734eb3f1726b649c90b0d7ea.svg";